import styled from 'styled-components';

import desktopBackground from '../../assets/images/RingSavvy-ICB-Hero.jpg';
import mobileBackground from '../../assets/images/RingSavvy-ICB-Hero_mobile.jpg';

export const Section = styled.section`
  background-image: url(${desktopBackground});
  height: 611px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  padding: 0 160px;
  background-size: cover;
  background-position: center;
  display: flex;
  position: relative;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    background-image: url(${mobileBackground});
    height: 802px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center; 
    text-align: left;
    padding: 40px 20px;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  max-width: 600px;
  color: white;
`;

export const Heading = styled.h1`
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 1rem;
  color: white;
  text-align: left;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    font-size: 36px;
  }
`;

export const Description = styled.p`
  font-size: 18px;
  margin-bottom: 2rem;
  line-height: 1.6;
  color: white;
  text-align: left;
`;

export const Button = styled.a`
  display: inline-block;
  background-color: #00B453;
  color: white;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border-radius: 36px;
  text-decoration: none;

  &:hover {
    background-color: #009d45;
  }
`;
